import { combineReducers } from 'redux';
import currentCaseStageImages from './caseStageImageReducer';
import notification from './notificationReducer';
import recentCases from './recentCasesReducer';
import searchFilter from './searchFilterReducer';
import searchElementReducer from './searchElementReducer';
import savedFilter from './savedFilterReducer';
import imageEditorData from './imageEditorReducer';
import drawer from './drawerReducer';
import appSearch from './appSearchReducer';
import transactionSearch from './transactionSearchReducer';
import nestedFieldSelectorData from './nestedFieldSelectorReducer';
import accountNumber from './accountNumberReducer';
import dataColumns from './dataColumnsReducer';
import auth from './authReducer';
import floatingPanelCords from './floatingPanelReducer';
import imageReader from './imageReaderReducer';
import organization from './organizationReducer';
import globalFilter from './globalFilterReducer';
import imageSelection from './imageSelectionReducer';
import toggleAppSearchPanelReducer from './toggleAppSearchPanelReducer';
import setMerchantDetailsReducer from './setMerchantDetailsReducer';
import reasonCode from './reasonCodeReducer';
import unResolvedBanner from './unResolvedBannerReducer';
import caseInfo from './caseDataReducer';
import activeCases from './activeCasesReducer';
import caseDocuments from './caseDocumentsReducer';
import accountsProfile from './accountsProfileReducer';

const combinedReducers = combineReducers({
  auth,
  notification,
  currentCaseStageImages,
  transactionSearch,
  recentCases,
  searchFilter,
  searchElementReducer,
  savedFilter,
  accountNumber,
  drawer,
  appSearch,
  imageEditorData,
  imageReader,
  nestedFieldSelectorData,
  dataColumns,
  floatingPanelCords,
  organization,
  globalFilter,
  imageSelection,
  toggleAppSearchPanelReducer,
  setMerchantDetailsReducer,
  reasonCode,
  caseInfo,
  unResolvedBanner,
  activeCases,
  caseDocuments,
  accountsProfile,
});

const rootReducer = (state, action) => {
  if (action.type === 'SYNC_STATE_FROM_V2_STORE') {
    return { ...action.newState };
  }
  return combinedReducers(state, action);
};

export default rootReducer;
